var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"value":_vm.modelValue,"items":_vm.fetchedItems,"loading":_vm.isLoading},on:{"input":(newValue) => (_vm.modelValue = newValue)}},'v-select',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }